import { render, staticRenderFns } from "./allotinHis.vue?vue&type=template&id=5884dfc0&scoped=true"
import script from "./allotinHis.vue?vue&type=script&lang=js"
export * from "./allotinHis.vue?vue&type=script&lang=js"
import style0 from "./allotinHis.vue?vue&type=style&index=0&id=5884dfc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884dfc0",
  null
  
)

export default component.exports